// A picked place: { lat, lng, address }. Kept the same shape as the portal's
// formBuilder/locationValue so both apps store and read the answer identically.

export const validCoordinates = (lat, lng) =>
  typeof lat === 'number' && Number.isFinite(lat) && lat >= -90 && lat <= 90
  && typeof lng === 'number' && Number.isFinite(lng) && lng >= -180 && lng <= 180;

export const isLocationValue = (value) => {
  if (!value || typeof value !== 'object') return false;
  return validCoordinates(value.lat, value.lng)
    && typeof value.address === 'string' && value.address.trim().length > 0 && value.address.length <= 1000;
};

export const formatLocationValue = (value) => {
  if (!isLocationValue(value)) return '—';
  return `${value.address} (${value.lat.toFixed(5)}, ${value.lng.toFixed(5)})`;
};
